var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.applicationStore.user.internal &&
      (_vm.applicationStore.userRight('C.ACCESS') ||
        _vm.applicationStore.userRight('C.NEW') ||
        _vm.applicationStore.userRight('C.EDIT'))
    )?_c('div',[_c('gat-tab',{attrs:{"items":_vm.tabs,"clientId":_vm.clientId,"show-in-toolbar":true}}),_c('keep-alive',[_c('router-view',{attrs:{"value":_vm.client,"location":"client","parentId":_vm.clientId}})],1)],1):_c('div',[_vm._v(" No access to clients. "),_c('br'),_vm._v(" Please contact your super user for access. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }